export const rtoolsApiEndpoint =
  'http://18.237.181.102';
export const cloudinaryImages =
  'https://res.cloudinary.com/rtools/image/upload';

